/**
 * @file project.form.tsx
 * @description Форма для создания и редактирования проектов в системе управления задачами.
 * Включает поля для указания кода проекта (только для чтения), наименования и родительского проекта.
 * Поддерживает иерархическую структуру проектов через возможность выбора родительского проекта.
 * Интегрируется с react-hook-form через control prop.
 * @author AI Assistant
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [react, @components/form-controls/text-field, @src/types, @components/form-controls/dictionary]
 * @related-files [@components/form-controls/text-field/text-field.component.tsx, @components/form-controls/dictionary/dictionary.component.tsx]
 */

import { TextField } from '@components/form-controls/text-field';
import { BaseForm } from '@src/types';
import { Dictionary } from '@components/form-controls/dictionary';
import { createCurrentItemsFromSingle } from '@utils/form-object-helper';

export const ProjectForm = ({ control, item }: BaseForm) => {
    return (
        <div className="flex flex-col gap-default w-[37.5874vmin]">
            <TextField name="code" label="Код" control={control} readOnly={true} />

            <TextField name="name" label="Наименование" control={control} />

            <Dictionary
                name="parent"
                label="Проект"
                control={control}
                currentItems={createCurrentItemsFromSingle(item)}
            />
        </div>
    );
};
